import { Messages } from '@app/components/Messages';
import {
  isAppliedMessage,
  isShippingMessage,
} from '@app/components/Messages/utils';
import { MonolithShippingOptionsContainer } from '@app/components/ShippingOptions/MonolithShippingOptionsContainer';
import {
  useCartAndDeliveryDatesDataContext,
  useUpdateShippingPreference,
} from '@app/data/clients/cartCheckoutClient';
import { serverErrorMessage } from '@app/pages/cart/errorDict';
import { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { Box } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { useCallback, useEffect, useMemo } from 'react';
import { DeliveryTo } from './DeliveryTo';
import styles from './Shipping.module.scss';

export const Shipping = ({
  handleServerError,
  clearServerError,
  handleShippingPreferenceLoading,
  allMessages,
  flatRateApplied,
}) => {
  const intl = useIntl();

  const { dispatch, client, cart } = useCartAndDeliveryDatesDataContext();

  const { handler: updateShippingPreference, state: shippingUpdateState } =
    useUpdateShippingPreference({ client, dispatch });

  const shippingMessages = useMemo(
    () => allMessages.filter(isShippingMessage).filter(isAppliedMessage),
    [allMessages]
  );

  const countryName = cart?.summary.estimated_shipping.country_name || '';

  useEffect(() => {
    handleShippingPreferenceLoading(shippingUpdateState === 'LOADING');
  }, [handleShippingPreferenceLoading, shippingUpdateState]);

  const onShippingOptionsChange = useCallback(
    async (selectedShippingMethod: ShippingMethod) => {
      clearServerError();
      const result = await updateShippingPreference(selectedShippingMethod);
      if (result.errors) {
        handleServerError(
          intl.formatMessage(serverErrorMessage.shippingPreferenceServerError)
        );
      }
      return result;
    },
    [clearServerError, handleServerError, intl, updateShippingPreference]
  );

  return (
    <Box className={styles.wrapper}>
      <Box marginBottom="l">
        <DeliveryTo countryName={countryName} />
      </Box>

      <Messages messages={shippingMessages} hideAppliedIcons />

      <Box>
        <MonolithShippingOptionsContainer
          flatRateApplied={flatRateApplied}
          onChange={onShippingOptionsChange}
        />
      </Box>
    </Box>
  );
};
